let dataPromises = {};

export function getData(url) {
  if (!dataPromises[url]) {
    dataPromises[url] = fetch(url)
      .then((res) => res.json())
      .catch((err) => {
        console.error(`Failed to load data from ${url}:`, err);
        return null;
      });
  }
  return dataPromises[url];
}
